import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "display-cover"
}
const _hoisted_2 = { class: "display-cover__video" }
const _hoisted_3 = {
  ref: "video",
  autoplay: ""
}
const _hoisted_4 = { class: "video-options" }
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  ref: "canvas",
  class: "d-none"
}
const _hoisted_7 = { class: "controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_ctx.isLoader)
    ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("video", _hoisted_3, null, 512),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.videoDevices.length > 0)
              ? (_openBlock(), _createElementBlock("select", {
                  key: 0,
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cameraOptionsChange && _ctx.cameraOptionsChange(...args))),
                  ref: "cameraOptions",
                  class: "custom-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoDevices, (videoDevice, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: videoDevice.deviceId,
                      key: index
                    }, _toDisplayString(videoDevice.label), 9, _hoisted_5))
                  }), 128))
                ], 544))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("canvas", _hoisted_6, null, 512),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            ref: "play",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cameraOptionsChange && _ctx.cameraOptionsChange(...args))),
            class: "btn btn-play"
          }, _toDisplayString(_ctx.Ti18N('scanner.cameraOn')), 513),
          _createElementVNode("button", {
            ref: "pause",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pauseStream && _ctx.pauseStream(...args))),
            class: "btn btn-info pause d-none"
          }, _toDisplayString(_ctx.Ti18N('scanner.stop')), 513),
          _createElementVNode("button", {
            ref: "screenshot",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.doScreenshot && _ctx.doScreenshot(...args))),
            class: "btn btn-outline-success screenshot d-none"
          }, _toDisplayString(_ctx.Ti18N('scanner.makePhoto')), 513)
        ])
      ]))
}